import React from 'react';
import Banner from '../Banner';
import styles from './gameLayout.module.css';

export interface GameLayoutProps{
    children?: React.ReactNode | React.ReactNode[];
    background?: string;
}

const Layout: React.FC<GameLayoutProps> = ({ children, background })=>{
    
    return(
        <div className={styles.container} style={{ background: background }}>
           <div className={styles.topContent}>
                <Banner/>
                {children}
           </div>
        </div>
    )
}

export default Layout;